var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ValidationProvider", {
    ref: "provider",
    class: { "opacity-75 cursor-not-allowed": _vm.disabled },
    attrs: {
      mode: _vm.eagerIfDirty,
      vid: _vm.name,
      name: _vm.validateAs,
      rules: _vm.rules,
      bails: false,
      tag: "div"
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var classes = ref.classes
          var errors = ref.errors
          return [
            _vm.label
              ? _c(
                  "label",
                  {
                    staticClass: "mb-8 block",
                    class: [classes, _vm.labelClass],
                    attrs: { for: "id_" + _vm.name }
                  },
                  [
                    _vm._v("\n        " + _vm._s(_vm.label) + "\n        "),
                    (_vm.rules &&
                      typeof _vm.rules === "string" &&
                      _vm.rules.includes("required")) ||
                    (typeof _vm.rules === "object" && _vm.rules.required)
                      ? _c("span", { staticClass: "text-red" }, [_vm._v("*")])
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "relative flex items-center",
                class: { "pointer-events-none": _vm.disabled }
              },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "left-24 absolute font-bold text-20 text-brown-400"
                  },
                  [_vm._v("BE")]
                ),
                _vm._v(" "),
                _vm.type === "checkbox"
                  ? _c(
                      "input",
                      _vm._g(
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.localValue,
                              expression: "localValue"
                            },
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "####.###.###",
                              expression: "'####.###.###'"
                            }
                          ],
                          ref: "input",
                          class: [
                            classes,
                            "w-full focus:outline-none flex items-center transition ease-in-out",
                            {
                              "!border-red":
                                errors[0] &&
                                ((classes.dirty && _vm.validAtleastOnce) ||
                                  _vm.formValdiated)
                            }
                          ],
                          style: { "padding-left": _vm.prefixWidth },
                          attrs: {
                            id: "id_" + _vm.name,
                            placeholder: _vm.placeholder,
                            "aria-describedby": "description_" + _vm.name,
                            type: "checkbox"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.localValue)
                              ? _vm._i(_vm.localValue, null) > -1
                              : _vm.localValue
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.localValue,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.localValue = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.localValue = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.localValue = $$c
                              }
                            }
                          }
                        },
                        Object.assign({}, _vm.$listeners, {
                          input: _vm.handleInput,
                          focus: _vm.handleFocus,
                          blur: _vm.handleBlur
                        })
                      )
                    )
                  : _vm.type === "radio"
                  ? _c(
                      "input",
                      _vm._g(
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.localValue,
                              expression: "localValue"
                            },
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "####.###.###",
                              expression: "'####.###.###'"
                            }
                          ],
                          ref: "input",
                          class: [
                            classes,
                            "w-full focus:outline-none flex items-center transition ease-in-out",
                            {
                              "!border-red":
                                errors[0] &&
                                ((classes.dirty && _vm.validAtleastOnce) ||
                                  _vm.formValdiated)
                            }
                          ],
                          style: { "padding-left": _vm.prefixWidth },
                          attrs: {
                            id: "id_" + _vm.name,
                            placeholder: _vm.placeholder,
                            "aria-describedby": "description_" + _vm.name,
                            type: "radio"
                          },
                          domProps: { checked: _vm._q(_vm.localValue, null) },
                          on: {
                            change: function($event) {
                              _vm.localValue = null
                            }
                          }
                        },
                        Object.assign({}, _vm.$listeners, {
                          input: _vm.handleInput,
                          focus: _vm.handleFocus,
                          blur: _vm.handleBlur
                        })
                      )
                    )
                  : _c(
                      "input",
                      _vm._g(
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.localValue,
                              expression: "localValue"
                            },
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "####.###.###",
                              expression: "'####.###.###'"
                            }
                          ],
                          ref: "input",
                          class: [
                            classes,
                            "w-full focus:outline-none flex items-center transition ease-in-out",
                            {
                              "!border-red":
                                errors[0] &&
                                ((classes.dirty && _vm.validAtleastOnce) ||
                                  _vm.formValdiated)
                            }
                          ],
                          style: { "padding-left": _vm.prefixWidth },
                          attrs: {
                            id: "id_" + _vm.name,
                            placeholder: _vm.placeholder,
                            "aria-describedby": "description_" + _vm.name,
                            type: _vm.type
                          },
                          domProps: { value: _vm.localValue },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.localValue = $event.target.value
                            }
                          }
                        },
                        Object.assign({}, _vm.$listeners, {
                          input: _vm.handleInput,
                          focus: _vm.handleFocus,
                          blur: _vm.handleBlur
                        })
                      )
                    )
              ]
            ),
            _vm._v(" "),
            _vm.showError &&
            errors[0] &&
            ((classes.dirty && _vm.validAtleastOnce) || _vm.formValdiated)
              ? _c("span", { staticClass: "text-red mt-8 block text-12" }, [
                  _vm._v(_vm._s(errors[0]))
                ])
              : _vm._e()
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }